export default "__VITE_ASSET__DZj2A$Y___"